module.exports = __webpack_public_path__ + "img/SketchPnga85bd4d2461d56b2c848fe598c30ecb70e2975abb0d5a26e67902928c756db31.f7f8884c.png";